<app-nav-menu [user]="user"></app-nav-menu>  <!--[user]="user"-->
<div class="container-fluid" id="mainContainer">
  <div class="row flex-nowrap">
    <app-sidebar [user] ="user"></app-sidebar>  <!--[user]="user"-->
    <main role="main" class="col py-3">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
